// Lightweight per-route <title> + <meta name="description"> + canonical setter.
// Avoids adding a dependency like react-helmet-async for a handful of routes.
//
// Usage inside a page component:
//   useSEO({
//     title: "Get Your Crystal Prescription | Pancha Healing",
//     description: "Take our 2-minute Vedic prescription quiz...",
//     canonical: "https://panchahealing.com/prescription",
//   });

import { useEffect } from "react";

const DEFAULT_TITLE = "Pancha Healing | Your crystals. Prescribed.";
const DEFAULT_DESCRIPTION =
  "Pancha Healing - Personalised Vedic crystal bracelets prescribed from your numerology and five elements.";

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, canonical, noIndex }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("description", description || DEFAULT_DESCRIPTION);
    if (canonical) upsertLink("canonical", canonical);
    upsertMeta("robots", noIndex ? "noindex, nofollow" : "index, follow");

    // Restore defaults on unmount so a route without useSEO gets the fallback title
    return () => {
      document.title = DEFAULT_TITLE;
      upsertMeta("description", DEFAULT_DESCRIPTION);
      upsertMeta("robots", "index, follow");
    };
  }, [title, description, canonical, noIndex]);
}
